// src/graphql/queries/getOrdersByTransactionId.ts
import { gql } from '@apollo/client';

export const GET_TRANSACTION_PRODUCTS = gql`
  query GetOrdersDetailsByTransactionId($transactionId: Int!) {
    orderDetailsByTransactionId(transactionId: $transactionId) {
      items {
        order_id
        order_number
        product_name
        sku
        price
        qty
        total_price
        total_tax
        coupon_amount
        shipping_amount
        commission
        subtotal
        image
      }
      order_totals
      {
        total_amount
        total_commission
        total_transaction
      }
      transaction_id
    }
  }
`;
